import { render, staticRenderFns } from "./variations-demo.vue?vue&type=template&id=487c2c74&scoped=true&"
import script from "./variations-demo.vue?vue&type=script&lang=js&"
export * from "./variations-demo.vue?vue&type=script&lang=js&"
import style0 from "./variations-demo.vue?vue&type=style&index=0&id=487c2c74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c2c74",
  null
  
)

export default component.exports